var Localizer = (function () {
    function Localizer(currentLanguage) {
        if (currentLanguage === void 0) { currentLanguage = "de"; }
        this.currentLanguage = currentLanguage;
        this.FillDictionary();
    }
    Localizer.prototype.FillDictionary = function () {
        this.Dictionary = {
            de: {
                'Klicken um auszuwählen': 'Klicken um auszuwählen',
                'Klicken um Gruppe auszuwählen': 'Klicken um Gruppe auszuwählen',
                'Ausgewählt': 'Ausgewählt',
                'Klicken um Auswahl aufzuheben': 'Klicken um Auswahl zu entfernen'
            },
            en: {
                'Klicken um auszuwählen': 'Press enter to select',
                'Klicken um Gruppe auszuwählen': 'Press enter to select group',
                'Ausgewählt': 'Selected',
                'Klicken um Auswahl aufzuheben': 'Press enter to remove'
            }
        };
    };
    Localizer.prototype.T = function (key) {
        return this.Translate(key);
    };
    Localizer.prototype.Translate = function (key) {
        var value;
        if (this.Dictionary.hasOwnProperty(this.currentLanguage) && this.Dictionary[this.currentLanguage].hasOwnProperty(key))
            value = this.Dictionary[this.currentLanguage][key];
        else
            value = key;
        return value;
    };
    return Localizer;
}());
window["Localizer"] = new Localizer($('html').attr('lang'));
//# sourceMappingURL=Localizer.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Controllers/Localizer.js
// module id = 368
// module chunks = 0